module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$hydrowareSecurityJS.canDisplay_A('managetemplates') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Manage Templates"
    }
  })], 1) : _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('readings-maintenance', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayingTabbedPanes),
      expression: "displayingTabbedPanes"
    }],
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "templateData": _vm.templateData
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.displayingTabbedPanes),
      expression: "!displayingTabbedPanes"
    }],
    staticClass: "container csettings",
    attrs: {
      "id": "vue-tables-options"
    }
  }, [_c('v-client-table', {
    staticClass: "hydroware-table",
    attrs: {
      "data": _vm.templates,
      "columns": _vm.Chemicalcolumns,
      "options": _vm.optionstable
    },
    scopedSlots: _vm._u([{
      key: "Name",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "padding-left": "10px"
          }
        }, [_vm._v(_vm._s(props.row.Name))])]
      }
    }, {
      key: "IsActive",
      fn: function(props) {
        return [_c('el-switch', {
          attrs: {
            "disabled": !_vm.$hydrowareSecurityJS.canEdit_A('managetemplates')
          },
          on: {
            "change": function($event) {
              return _vm.toggleActivateButton(props.row)
            }
          },
          model: {
            value: (props.row.IsActive),
            callback: function($$v) {
              _vm.$set(props.row, "IsActive", $$v)
            },
            expression: "props.row.IsActive"
          }
        })]
      }
    }, {
      key: "Actions",
      fn: function(props) {
        return [_c('div', [_c('hydroware-viewOrEdit-button', {
          attrs: {
            "EV": _vm.$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('managetemplates')
          },
          on: {
            "click": function($event) {
              return _vm.editATemplate(props.row)
            }
          }
        }), _vm._v(" "), (_vm.$hydrowareSecurityJS.canAdd_A('managetemplates')) ? _c('hydroware-copy-button', {
          on: {
            "click": function($event) {
              return _vm.copy([props.row.Id])
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.$hydrowareSecurityJS.canDelete_A('managetemplates')) ? _c('hydroware-delete-button', {
          on: {
            "click": function($event) {
              return _vm.del(props)
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  }, [(_vm.$hydrowareSecurityJS.canAdd_A('managetemplates')) ? _c('hydroware-add-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isediting),
      expression: "!isediting"
    }],
    attrs: {
      "slot": "beforeLimit"
    },
    on: {
      "click": function($event) {
        return _vm.displayAddTemplatePage()
      }
    },
    slot: "beforeLimit"
  }) : _vm._e()], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v(" Manage Templates ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee7d148"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChemicalChecklist/chemicalsettings.vue
// module id = 835
// module chunks = 1